import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-alert-details',
  templateUrl: './view-alert-details.component.html',
  styleUrls: ['./view-alert-details.component.scss'],
})
export class ViewAlertDetailsComponent {
  title: string;

  constructor(
    public dialogRef: MatDialogRef<ViewAlertDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.title = data?.title;
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }
}
